import { 
  GetClientAndCampaignsRequestDto,
  GetClientAndCampaignsResponseDto,
  GetExploreDataRequestDto,
  GetExploreDataResponseDto,
  GetAllExploreSectionsRequestDto,
  GetAllExploreSectionsResponseDto,
  ClientWithLocations,
  CampaignClientPair
} from '@foodfluence/shared';
import { SectionKey } from 'features/explore/utils';
import { apiRequest } from './apiUtils';

export const exploreApi = {
  getClientAndCampaigns: async (
    params: GetClientAndCampaignsRequestDto
  ): Promise<GetClientAndCampaignsResponseDto> => {
    return apiRequest({
      method: 'GET',
      endpoint: `/explore/client/${params.clientId}/campaigns`
    });
  },

  getExploreData: async (
    section: SectionKey,
    cursor?: string | null,
    filters?: {
      searchQuery?: string;
      location?: { lat: number; lng: number; radius: number };
      creatorTypes?: ('influencer' | 'ugc')[];
    }
  ): Promise<GetExploreDataResponseDto> => {
    const params = new URLSearchParams();
    if (cursor) params.append('cursor', cursor);
    if (filters?.searchQuery) params.append('searchQuery', filters.searchQuery);
    if (filters?.location) {
      params.append('lat', filters.location.lat.toString());
      params.append('lng', filters.location.lng.toString());
      params.append('radius', filters.location.radius.toString());
    }
    if (filters?.creatorTypes) {
      filters.creatorTypes.forEach(type => params.append('creatorTypes[]', type));
    }

    return apiRequest({
      method: 'GET',
      endpoint: `/explore/data/${section}?${params.toString()}`
    });
  },

  getAllSections: async (
    filters?: Omit<GetAllExploreSectionsRequestDto, 'limit'>,
    limit: number = 10
  ): Promise<GetAllExploreSectionsResponseDto> => {
    const params = new URLSearchParams({
      limit: limit.toString()
    });
    if (filters?.searchQuery) params.append('search', filters.searchQuery);
    if (filters?.location) {
      params.append('lat', filters.location.lat.toString());
      params.append('lng', filters.location.lng.toString());
      params.append('radius', filters.location.radius.toString());
    }
    if (filters?.campaignTypes && filters.campaignTypes.length > 0) {
      params.append('campaignTypes', filters.campaignTypes.join(','));
    }
    if (filters?.creatorTypes && filters.creatorTypes.length > 0) {
      filters.creatorTypes.forEach(type => params.append('creatorTypes[]', type));
    }
    return apiRequest({
      method: 'GET',
      endpoint: `/explore/all-sections?${params.toString()}`
    });
  }
}; 